/**
 * Download a file from a URL (works with cross-origin presigned S3 URLs)
 *
 * The HTML `download` attribute does not work on cross-origin URLs,
 * so we fetch the file as a Blob and trigger a programmatic download.
 */
export function initDownloadFile() {
	window.wpcore = window.wpcore || {};

	/**
	 * @param {string} url      - The file URL (presigned S3 URL)
	 * @param {string} filename - The filename for the downloaded file
	 */
	window.wpcore.downloadFile = async (url, filename) => {
		try {
			const response = await fetch(url);
			if (!response.ok) throw new Error('Download failed');

			const blob = await response.blob();
			const blobUrl = URL.createObjectURL(blob);

			const a = document.createElement('a');
			a.href = blobUrl;
			a.download = filename;
			document.body.appendChild(a);
			a.click();

			// Cleanup
			setTimeout(() => {
				document.body.removeChild(a);
				URL.revokeObjectURL(blobUrl);
			}, 100);
		} catch (error) {
			console.error('[Download]', error);
			window.wpcore.alert?.('error', wpcore.direct_t({ en: 'Download', fr: 'Télécharger' }), wpcore.direct_t({ en: 'Failed to download file.', fr: 'Échec du téléchargement du fichier.' }));
		}
	};
}
